import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconLeadStageGoal = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm2.18-14.4h1.92l2.4 4.364-2.4 4.363h-1.92l2.4-4.363-2.4-4.364zm-3.84 0h1.92l2.4 4.364-2.4 4.363H8.34l2.4-4.363L8.34 5.6zm-3.84 0h1.92l2.4 4.364-2.4 4.363H4.5l2.4-4.363L4.5 5.6z",
		fill: "currentColor"
	})
});
export default SvgIconLeadStageGoal;
